import styled from "styled-components";
import { BREAK_POINT } from "../constants";

const Banner = () => {
  return <Wrapper />;
};

export default Banner;

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 162px;
  background-image: url("/assets/banner.png");
  height: 0;
  padding: 0;
  padding-bottom: 17%;
  background-position: center center;
  background-size: 100%;
  background-repeat: no-repeat;

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    margin-bottom: 24px;
  }

  @media only screen and (max-width: ${BREAK_POINT.mobile}) {
    margin-bottom: 24px;
    padding-bottom: 34%;
    background-image: url("/assets/banner_mobile.png");
  }
`;
